import formatMoney from '../../../../scripts/utils/formatMoney';
import getLocalWishlist from '../utils/getLocalWishlist';
import SELECTORS from '../utils/vars/SELECTORS';

if (!customElements.get('wishlist-page')) {
  class WishlistPage extends HTMLElement {
    constructor() {
      super();

      this.addToCartButton = this.querySelector(SELECTORS.WISHLIST_ADD_TO_CART_DATASET);
    }

    connectedCallback() {
      this.setupGrid();
      this.setupEventListeners();
    }

    setupEventListeners() {
      document.addEventListener('wishlist:updated', this.setupGrid.bind(this));
      document.addEventListener('wishlist:render-content', this.updateTotalPrice.bind(this));
      this.addToCartButton?.addEventListener('click', this.addWishlistToCart.bind(this));
      document.addEventListener('productcard:datapriceupdated', this.updateTotalPrice.bind(this))
    }

    get wishlistGrid() {
      return this.querySelector(SELECTORS.WISHLIST_GRID);
    }

    get items() {
      return Array.from(this.querySelectorAll('[data-js-product-item] quick-buy'));
    }

    async setupGrid() {
      if (!this.wishlistGrid) return;
      const wishlist = getLocalWishlist();
      const requests = wishlist.map(this.fetchProductCardHTML);
      const responses = await Promise.all(requests);

      const wishlistProductCards = responses.join('');
      this.renderWishlistContent(wishlistProductCards);
    }

    renderWishlistContent(wishlistProductCards) {
      const wishlistEmpty = this.querySelector(SELECTORS.WISHLIST_EMPTY);
      const wishlistGridWrapper = this.querySelector(SELECTORS.WISHLIST_GRID_WRAPPER);

      if (wishlistProductCards) {
        if (wishlistEmpty) {
          wishlistEmpty.classList.add('hidden');
        }
        if (wishlistGridWrapper) {
          wishlistGridWrapper.classList.remove('hidden');
        }
        this.wishlistGrid.innerHTML = wishlistProductCards;
      } else {
        if (wishlistEmpty) {
          wishlistEmpty.classList.remove('hidden');
        }
        if (wishlistGridWrapper) {
          wishlistGridWrapper.classList.add('hidden');
        }
        this.wishlistGrid.innerHTML = '';
      }

      const event = new CustomEvent('wishlist:render-content', {});
      document.dispatchEvent(event);
    }

    async fetchProductCardHTML(handle) {
      const productTileTemplateUrl = `/products/${handle}?view=product-item`;

      try {
        const res = await fetch(productTileTemplateUrl);
        const res_2 = await res.text();
        const text = res_2;
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(text, 'text/html');

        const productCard = htmlDocument.documentElement.querySelector('[data-js-product-item]');
        if (productCard) return productCard.outerHTML;
      } catch (err) {
        return console.error(`[Wishlist] Failed to load content for handle: ${handle}`, err);
      }
    }

    async addWishlistToCart() {
      try {
        const formData = {};
        formData.items = [];

        this.items.forEach((item) => {
          const variantId = item.dataset.variantId;
          if (variantId) {
            formData.items.push({
              id: variantId,
              quantity: 1,
            });
          }
        });

        await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(formData),
        });

        window.refreshCart();
        document.querySelector('#site-cart-sidebar').show();
      } catch (error) {
        console.error('Failed to add product to cart', error);
      }
    }

    updateTotalPrice() {
      const wishlistProductCards = this.querySelectorAll('.wishlist__grid > [data-js-product-item]');
      const totalPriceElement = this.querySelector(SELECTORS.WISHLIST_ADD_TO_CART_DATASET).querySelector('span');
      if (!wishlistProductCards || !totalPriceElement) return;

      const totalPrice = Array.from(wishlistProductCards).reduce((acc, productCard) => {
        const price = productCard.dataset.price;

        if (!price) return acc;

        const priceValue = parseFloat(price.replace(/[^0-9.-]+/g, ''));
        return acc + priceValue;
      }, 0);

      const formattedTotalPrice = formatMoney(totalPrice, KROWN.settings.shop_money_format);

      if (formattedTotalPrice) totalPriceElement.replaceWith(formattedTotalPrice);
    }
  }
  customElements.define('wishlist-page', WishlistPage);
}
